// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/canvases_data/" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasesData } from "./constants";
import type { EngagementCanvasesDataParams, EngagementCanvasesDataResult } from "./types";

const formatTime = (type: string, startDate?: number, endDate?: number) => {
  if (startDate && endDate) {
    return {
      [type]: {
        start_date: startDate,
        end_date: endDate,
      },
    };
  }
};

export const getDataTableEngagementCanvasesData = reactQueryTableFetcherAdapter(
  engagementCanvasesData,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
      ignoreSavedQuery = false,
    }: EngagementCanvasesDataParams
  ): Promise<EngagementCanvasesDataResult> => {
    const { last_edited_start_date, last_edited_end_date, created_start_date, created_end_date, ...strippedQuery } =
      query;

    return fetch(
      "/engagement/canvases_data/",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        ignore_saved_query: ignoreSavedQuery,
        query: serializeQueryObjects(
          {
            ...strippedQuery,
            ...formatTime("edited", last_edited_start_date, last_edited_end_date),
            ...formatTime("created", created_start_date, created_end_date),
          },
          true
        ),
      },
      { signal }
    );
  }
);
